import React, { useEffect, useState } from "react";
import {
  DialogTitle,
  DialogContentText,
  DialogContent,
  Dialog,
  Button,
  DialogActions,
  Grid,
} from "@mui/material";
import axios from "axios";
import { BaseUrl } from "../../../../Container/BaseUrl/BaseUrl";
import { connect } from "react-redux";
import {
  GetAllUsers,
  setExternalChatData,
} from "../../../../Redux/Actions/actions";
import { toast } from "react-toastify";
import { toaststyle } from "../../../../Utils/toaststyle";

const mapStateToProps = (state) => {
  const { contactListData } = state;
  return {
    externalChatData: contactListData.externalChatData,
  };
};

const EditUser = (props) => {
  const { OpenDialog, handleClose } = props;
  const [editUser, setEditUser] = useState(true);
  const [CustomerDetailSearch, setCustomerDetailSearch] = useState(false);
  const [editemail, seteditemail] = useState();
  const [editusername, seteditusername] = useState();
  const [editlasName, seteditlasName] = useState();
  const [editmobile, seteditmobile] = useState();
  const [editwhatsapp, seteditwhatsapp] = useState();
  const [editfacebook, seteditfacebook] = useState();
  const [edittwitter, setedittwitter] = useState();
  const [editteams, seteditteams] = useState();
  const [editcompany, seteditcompany] = useState();
  const [editAddress, seteditAddress] = useState();
  const [editCity, seteditCity] = useState();
  const [editpostalcode, setpostalcode] = useState();
  const [editCountry, seteditCountry] = useState();
  const [editstate, seteditstate] = useState();
  const [editType, seteditType] = useState();
  const [editLanguage, seteditLanguage] = useState();

  const updateEditvalue = async () => {
    const loggedInAgent = JSON.parse(localStorage.getItem("tokenAgent"));
    let body = {
      language: editLanguage,
      Lastname: editlasName,
      address: editAddress,
      city: editCity,
      company: editcompany,
      country: editCountry,
      email: editemail,
      facebookId: editfacebook,
      id: props.externalChatData ? props.externalChatData.unique_id.id : "",
      type: editType,
      phonenumber: editmobile,
      postalcode: editpostalcode,
      state: editstate,
      teamsId: editteams,
      twitterId: edittwitter,
      username: editusername,
      whatsappnumber: editwhatsapp,
      agent_id: loggedInAgent.id,
      chat_session_id: props.externalChatData
        ? props.externalChatData.chat_session_id
        : "",
    };
    await axios
      .post(BaseUrl + "/users/updateClient", body, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        if (res.data.status) {
          props.GetAllUsers();
          props.setExternalChatData("");
          toast.success("Client Updated Successfully", toaststyle);
          handleClose();
        } else {
          props.setExternalChatData("");
          toast.error(res.data.message, toaststyle);
          handleClose();
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  useEffect(() => {
    seteditusername(
      props.externalChatData
        ? props.externalChatData.unique_id
          ? props.externalChatData.unique_id.username
          : "NA"
        : "NA"
    );
    seteditemail(
      props.externalChatData
        ? props.externalChatData.unique_id
          ? props.externalChatData.unique_id.email
          : "NA"
        : "NA"
    );
    seteditwhatsapp(
      props.externalChatData
        ? props.externalChatData.unique_id
          ? props.externalChatData.unique_id.whatsappnumber
          : "NA"
        : "NA"
    );
    seteditmobile(
      props.externalChatData ? props.externalChatData.phonenumber : "NA"
    );
    seteditfacebook(
      props.externalChatData
        ? props.externalChatData.unique_id
          ? props.externalChatData.unique_id.facebookId
          : "NA"
        : "NA"
    );

    setedittwitter(
      props.externalChatData
        ? props.externalChatData.unique_id
          ? props.externalChatData.unique_id.twitterId
          : "NA"
        : "NA"
    );
    seteditteams(
      props.externalChatData
        ? props.externalChatData.unique_id
          ? props.externalChatData.unique_id.teamsId
          : "NA"
        : "NA"
    );
    seteditcompany(
      props.externalChatData
        ? props.externalChatData.unique_id
          ? props.externalChatData.unique_id.company
          : "NA"
        : "NA"
    );
    setpostalcode(
      props.externalChatData
        ? props.externalChatData.unique_id
          ? props.externalChatData.unique_id.address
          : "NA"
        : "NA"
    );

    seteditType(
      props.externalChatData
        ? props.externalChatData.unique_id
          ? props.externalChatData.unique_id.Type
          : "NA"
        : "NA"
    );

    seteditCountry(
      props.externalChatData
        ? props.externalChatData.unique_id
          ? props.externalChatData.unique_id.country
          : "NA"
        : "NA"
    );
    seteditstate(
      props.externalChatData
        ? props.externalChatData.unique_id
          ? props.externalChatData.unique_id.state
          : "NA"
        : "NA"
    );

    seteditLanguage(
      props.externalChatData
        ? props.externalChatData.unique_id
          ? props.externalChatData.unique_id.Language
          : "NA"
        : "NA"
    );

    seteditCity(
      props.externalChatData
        ? props.externalChatData.unique_id
          ? props.externalChatData.unique_id.city
          : "NA"
        : "NA"
    );

    seteditlasName(
      props.externalChatData
        ? props.externalChatData.unique_id
          ? props.externalChatData.unique_id.Lastname
          : "NA"
        : "NA"
    );

    seteditAddress(
      props.externalChatData
        ? props.externalChatData.unique_id
          ? props.externalChatData.unique_id.address
          : "NA"
        : "NA"
    );
  }, [props.externalChatData]);
  return (
    <Dialog
      open={OpenDialog}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle
        variant="subtitle2"
        sx={{
          fontSize: "16px",
          fontWeight: 600,
          boxShadow:
            "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
        }}
      >
        Edit user
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-slide-description"
          className="mt-3"
          sx={{ display: "flex", justifyContent: "center" }}
        >
          <Grid container spacing={1}>
            <Grid item xs={4}>
              <label for="formFile" className="form-label fs-13">
                First Name
              </label>
              <input
                type="text"
                className="form-control fs-13"
                id="floatingInputGrid"
                value={editusername}
                onChange={(e) => seteditusername(e.target.value)}
              />
            </Grid>
            <Grid item xs={4}>
              <label for="formFile" className="form-label fs-13">
                Last Name
              </label>
              <input
                type="text"
                className="form-control fs-13"
                id="floatingInputGrid"
                value={editlasName}
                onChange={(e) => seteditlasName(e.target.value)}
              />
            </Grid>
            <Grid item xs={4}>
              <label for="formFile" className="form-label fs-13">
                Type
              </label>
              <input
                type="text"
                className="form-control fs-13"
                id="floatingInputGrid"
                value={editType}
                onChange={(e) => seteditType(e.target.value)}
              />
            </Grid>
            <Grid item xs={4}>
              <label for="formFile" className="form-label fs-13">
                Phone
              </label>
              <input
                type="text"
                className="form-control fs-13"
                id="floatingInputGrid"
                value={editmobile}
                onChange={(e) =>
                  seteditmobile(e.target.value.replace(/[^\d]/, ""))
                }
              />
            </Grid>
            <Grid item xs={4}>
              <label for="formFile" className="form-label fs-13">
                Email
              </label>
              <input
                type="email"
                className="form-control fs-13"
                id="floatingInputGrid"
                value={editemail}
                onChange={(e) => seteditemail(e.target.value)}
                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
              />
            </Grid>
            <Grid item xs={4}>
              <label for="formFile" className="form-label fs-13">
                Language
              </label>
              <input
                type="text"
                className="form-control fs-13"
                id="floatingInputGrid"
                value={editLanguage}
                onChange={(e) => seteditLanguage(e.target.value)}
              />
            </Grid>
            <Grid item xs={4}>
              <label for="formFile" className="form-label fs-13">
                Company
              </label>
              <input
                type="text"
                className="form-control fs-13"
                id="floatingInputGrid"
                value={editcompany}
                onChange={(e) => seteditcompany(e.target.value)}
              />
            </Grid>
            <Grid item xs={4}>
              <label for="formFile" className="form-label fs-13">
                City
              </label>
              <input
                type="text"
                className="form-control fs-13"
                id="floatingInputGrid"
                value={editCity}
                onChange={(e) => editCity(e.target.value)}
              />
            </Grid>
            <Grid item xs={4}>
              <label for="formFile" className="form-label fs-13">
                State
              </label>
              <input
                type="text"
                className="form-control fs-13"
                id="floatingInputGrid"
                value={editstate}
                onChange={(e) => seteditstate(e.target.value)}
              />
            </Grid>
            <Grid item xs={4}>
              <label className="custom-control-label  fs-13" for="customCheck1">
                Postal Code
              </label>
              <input
                type="text"
                className="form-control fs-13"
                id="floatingInputGrid"
                value={editpostalcode}
                onChange={(e) => setpostalcode(e.target.value)}
              />
            </Grid>
            <Grid item xs={4}>
              <label className="custom-control-label  fs-13" for="customCheck1">
                Country
              </label>
              <input
                type="text"
                className="form-control fs-13"
                id="floatingInputGrid"
                value={editCountry}
                onChange={(e) => seteditCountry(e.target.value)}
              />
            </Grid>
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          sx={{ textTransform: "capitalize !important" }}
          variant="outlined"
          onClick={() => {
            handleClose();
          }}
          size="small"
          disableElevation
          color="error"
          autoFocus
        >
          Close
        </Button>
        <Button
          sx={{ textTransform: "capitalize !important" }}
          variant="contained"
          size="small"
          disableElevation
          id="update-user"
          onClick={() => {
            updateEditvalue();
          }}
        >
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default connect(mapStateToProps, {
  GetAllUsers,
  setExternalChatData,
})(EditUser);
